import clsx from 'clsx'
import React, { FC, ReactNode } from 'react'

import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { RoundCheckbox } from '@Shared/Components/Inputs/Checkbox/RoundCheckbox'

import styles from './CheckoutPaymentOption.module.scss'

export interface CheckoutPaymentOptionProps {
  disabled?: boolean
  hide?: boolean
  icon?: ReactNode
  isSelected: boolean
  onClick: () => void
  title: string
}

export const CheckoutPaymentOption: FC<CheckoutPaymentOptionProps> = ({ disabled, hide, icon, isSelected, onClick, title }) => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')

  const renderIcon = () => {
    if (React.isValidElement(icon)) {
      return (
        <span
          className={clsx(
            'className' in (icon.props as any) && (icon.props as any).className,
            'name' in (icon.props as any) && styles[(icon.props as any).name],
            'deliveryType' in (icon.props as any) && styles[(icon.props as any).deliveryType],
            styles.icon,
          )}
        >
          {icon}
        </span>
      )
    }
    return null
  }

  if (hide) {
    return null
  }

  if (cofDesignV1) {
    const accessibleId = `payment-option-${title.replaceAll(/\s+/g, '-').toLowerCase()}`
    return (
      <div
        className={clsx(
          styles.checkoutPaymentOption,
          isSelected && styles.selectedPaymentOption,
          disabled && styles.disabledPaymentOption,
          cofDesignV1 && styles.cofDesignV1,
        )}
        onClick={() => {
          if (!disabled) {
            onClick()
          }
        }}
      >
        <RoundCheckbox ariaLabelledby={accessibleId} checked={isSelected} className={styles.disabled} tabIndex={-1} />
        <span className={clsx(styles.title, isSelected && styles.selectedTitle)} id={accessibleId}>{title}</span>
        {renderIcon()}
      </div>
    )
  }

  return (
    <button
      className={clsx(
        styles.checkoutPaymentOption,
        isSelected && styles.selectedPaymentOption,
        disabled && styles.disabledPaymentOption,
      )}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      <span className={styles.iconWrapper}>
        <RoundCheckbox checked={isSelected} className={styles.disabled} />
        <span className={styles.icon}>
          {icon}
        </span>
      </span>
      <span className={clsx(styles.title, isSelected && styles.selectedTitle)}>{title}</span>
    </button>
  )
}
